import ApprovedTable from './Approved.gql';

export default ApprovedTable;
